(() => {
  function initGalleryPreviews() {
    document.querySelectorAll('theme-media-gallery').forEach((gallery) => {
      const previews = gallery.querySelector('.jdm-gallery-previews');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const list = viewer?.querySelector('.product__media-list');
      if (!previews || !viewer || !list || previews.dataset.jdmInitialized) return;
      previews.dataset.jdmInitialized = 'true';
      const pinnedVideos = previews.querySelector('[data-jdm-pinned-videos]');
      if (pinnedVideos) {
        // Native selection still owns clicks, aria-current and media activation.
        // A pinned video is outside the photo slider, so never scroll photos for it.
        customElements.whenDefined('slider-component').then(() => {
          const isPhotoVisible = previews.isSlideVisible.bind(previews);
          previews.isSlideVisible = (thumbnail, offset) => {
            if (thumbnail && pinnedVideos.contains(thumbnail)) {
              const bounds = pinnedVideos.getBoundingClientRect();
              const item = thumbnail.getBoundingClientRect();
              if (item.left < bounds.left || item.right > bounds.right) {
                pinnedVideos.scrollTo({ left: thumbnail.offsetLeft });
              }
              return true;
            }
            return isPhotoVisible(thumbnail, offset);
          };
        });
      }
      const getSlides = () => Array.from(list.children).filter((slide) => slide.matches('li[data-media-id]') && !slide.hidden && getComputedStyle(slide).display !== 'none');
      const mobileGallery = matchMedia('(max-width: 749.98px)');
      const sizeGallery = (mediaId) => {
        if (!mobileGallery.matches) {
          list.style.removeProperty('--jdm-gallery-height');
          return;
        }
        const slide = getSlides().find((item) => item.dataset.mediaId === mediaId);
        const media = slide?.querySelector('.product-media-container');
        const ratio = Number(media?.dataset.naturalRatio);
        if (!ratio || !slide.clientWidth) return;
        const height = `${Math.round(slide.clientWidth / ratio)}px`;
        if (list.style.getPropertyValue('--jdm-gallery-height') !== height) list.style.setProperty('--jdm-gallery-height', height);
      };
      // Native thumbnail clicks keep setActiveMedia and deferred video activation intact.
      // Synchronize by stable media ID; preview order deliberately differs from slide order.
      const markActive = (mediaId) => {
        sizeGallery(mediaId);
        previews.querySelectorAll('button[data-media-id]').forEach((button) => {
          if (button.dataset.mediaId === mediaId) {
            if (button.getAttribute('aria-current') !== 'true') button.setAttribute('aria-current', 'true');
          } else if (button.hasAttribute('aria-current')) button.removeAttribute('aria-current');
        });
      };
      const syncActive = () => {
        const slides = getSlides();
        const active = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
        if (active) markActive(active.dataset.mediaId);
      };
      let scrollFrame;
      const syncVisibleSlide = () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = null;
          const slides = getSlides();
          const listRect = list.getBoundingClientRect();
          if (!listRect.width) return;
          const center = listRect.left + listRect.width / 2;
          const closest = slides.reduce((best, slide) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs((rect.left + rect.right) / 2 - center);
            return !best || distance < best.distance ? { slide, distance } : best;
          }, null);
          if (closest) markActive(closest.slide.dataset.mediaId);
        });
      };
      viewer.addEventListener('slideChanged', (event) => {
        const slide = event.detail?.currentElement;
        if (slide) markActive(slide.dataset.mediaId);
      });
      list.addEventListener('scroll', syncVisibleSlide, { passive: true });
      let rebuildFrame;
      new MutationObserver((records) => {
        const relevant = records.some((record) =>
          record.type === 'childList' ? record.target === list : record.target.parentElement === list && record.target.matches('li[data-media-id]')
        );
        if (!relevant || rebuildFrame) return;
        rebuildFrame = requestAnimationFrame(() => {
          rebuildFrame = null;
          syncActive();
        });
      }).observe(list, { childList: true, attributes: true, subtree: true, attributeFilter: ['class', 'hidden'] });
      let observedWidth;
      new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (width === observedWidth) return;
        observedWidth = width;
        syncVisibleSlide();
      }).observe(list);
      mobileGallery.addEventListener('change', () => {
        if (!mobileGallery.matches) list.style.removeProperty('--jdm-gallery-height');
        syncVisibleSlide();
      });
      syncActive();
      gallery.classList.add('jdm-gallery-ready');
    });
  }
  function initBundleDisclosure() {
    const config = document.getElementById('sticky-prod-header');
    const root = document.getElementById('frequently-bought-together-app-block');
    if (!config || !root || root.dataset.jdmDisclosure) return;
    root.dataset.jdmDisclosure = 'true';
    let expanded = false;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jdm-bundle-toggle';
    const refresh = () => {
      const panels = Array.from(root.querySelectorAll('.cbb-frequently-bought-selector-list'));
      if (!panels.length) return;
      const ids = panels.map((panel, index) => {
        if (!panel.id) panel.id = `jdm-bundle-panel-${index}`;
        if (panel.hidden !== !expanded) panel.hidden = !expanded;
        if (panel.inert !== !expanded) panel.inert = !expanded;
        if (panel.getAttribute('aria-hidden') !== String(!expanded)) panel.setAttribute('aria-hidden', String(!expanded));
        return panel.id;
      });
      if (root.classList.contains('jdm-bundle-collapsed') !== !expanded) root.classList.toggle('jdm-bundle-collapsed', !expanded);
      if (button.getAttribute('aria-expanded') !== String(expanded)) button.setAttribute('aria-expanded', String(expanded));
      if (button.getAttribute('aria-controls') !== ids.join(' ')) button.setAttribute('aria-controls', ids.join(' '));
      const label = expanded ? config.dataset.bundleCollapse : config.dataset.bundleExpand;
      if (button.textContent !== label) button.textContent = label;
      if (!root.contains(button)) {
        const pictures = root.querySelector('.cbb-frequently-bought-products');
        if (pictures) pictures.insertAdjacentElement('afterend', button);
        else root.prepend(button);
      }
    };
    button.addEventListener('click', () => { expanded = !expanded; refresh(); });
    let refreshFrame;
    new MutationObserver((records) => {
      if (records.every((record) => record.target === button || button.contains(record.target))) return;
      if (refreshFrame) return;
      refreshFrame = requestAnimationFrame(() => {
        refreshFrame = null;
        refresh();
      });
    }).observe(root, { childList: true, subtree: true });
    refresh();
  }
  function choiceRowSizes(count) {
    const rows = [];
    while (count > 0) {
      const size = count <= 3 ? count : count === 4 ? 2 : 3;
      rows.push(size);
      count -= size;
    }
    return rows;
  }
  function choiceColumnsForWidths(widths, availableWidth, gap) {
    const columns = [];
    while (columns.length < widths.length) {
      const start = columns.length;
      let size = choiceRowSizes(widths.length - start)[0];
      while (size > 1 && widths.slice(start, start + size).some((width) => width > (availableWidth - gap * (size - 1)) / size)) size -= 1;
      columns.push(...Array(size).fill(String(size)));
    }
    return columns;
  }
  let choiceTextContext;
  function choiceTextWidth(element) {
    if (!element || element.closest('.gpo-tooltip,.gpo-ov-helptext,.label-tooltip__content,.visually-hidden')) return 0;
    const style = getComputedStyle(element);
    if (element.hidden || style.display === 'none' || style.visibility === 'hidden') return 0;
    if (!choiceTextContext) choiceTextContext = document.createElement('canvas').getContext('2d');
    if (!choiceTextContext) return Infinity; // Readable full rows if text measurement is unavailable.
    let width = 0;
    element.childNodes.forEach((node) => {
      if (node.nodeType === 1) {
        width += choiceTextWidth(node);
      } else if (node.nodeType === 3) {
        let text = node.textContent.replace(/\s+/g, ' ');
        if (style.textTransform === 'uppercase') text = text.toLocaleUpperCase();
        else if (style.textTransform === 'lowercase') text = text.toLocaleLowerCase();
        else if (style.textTransform === 'capitalize') text = text.replace(/\b\w/g, (letter) => letter.toLocaleUpperCase());
        choiceTextContext.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        width += choiceTextContext.measureText(text).width + Math.max(0, Array.from(text).length - 1) * (parseFloat(style.letterSpacing) || 0);
      }
    });
    return width + (parseFloat(style.marginInlineStart) || 0) + (parseFloat(style.marginInlineEnd) || 0);
  }
  function choiceLabelWidth(label, textElement) {
    if (!label || !textElement) return Infinity;
    const style = getComputedStyle(label);
    let width = choiceTextWidth(textElement);
    label.querySelectorAll('.addOn').forEach((price) => { if (!textElement.contains(price)) width += choiceTextWidth(price); });
    return width + ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'].reduce((total, property) => total + (parseFloat(style[property]) || 0), 0) + 4;
  }
  function initOptionRows() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      if (root.dataset.jdmOptionRows) return;
      root.dataset.jdmOptionRows = 'true';
      let sizeObserver;
      let optionObserver;
      let observedContainer;
      const update = () => {
        const infoWrapper = root.querySelector('.product__info-wrapper');
        const container = infoWrapper && getComputedStyle(infoWrapper).display !== 'contents' ? infoWrapper : root;
        if (sizeObserver && observedContainer !== container) {
          sizeObserver.disconnect();
          observedContainer = container;
          sizeObserver.observe(container);
        }
        // Use the grid's normal tracks, never a previously expanded label's width.
        root.querySelectorAll('variant-selects .product-form__input--box:not(.product-form__input--swatch-box)').forEach((group) => {
          if (!group.clientWidth) return;
          const tracks = getComputedStyle(group).gridTemplateColumns.split(/\s+/).map(parseFloat).filter((width) => width > 0);
          const columnWidth = tracks.length ? Math.min(...tracks) : group.clientWidth;
          group.querySelectorAll(':scope > input[type="radio"] + label').forEach((label) => {
            const wide = choiceLabelWidth(label, label.querySelector('.swatch-input__label-inner')) > columnWidth;
            if (wide && !label.hasAttribute('data-jdm-choice-wide')) label.setAttribute('data-jdm-choice-wide', '');
            else if (!wide && label.hasAttribute('data-jdm-choice-wide')) label.removeAttribute('data-jdm-choice-wide');
          });
        });
        root.querySelectorAll('.gpo-app').forEach((app) => {
          let precedingVisibleField = false;
          app.querySelectorAll('.gpo-form__group.gpo-element').forEach((field) => {
            const visible = !field.hidden && field.getClientRects().length && getComputedStyle(field).display !== 'none' && getComputedStyle(field).visibility !== 'hidden' && field.querySelector('.gpo-label:not(.hidden)');
            const follows = Boolean(visible && precedingVisibleField);
            if (follows && !field.hasAttribute('data-jdm-option-following')) field.setAttribute('data-jdm-option-following', '');
            else if (!follows && field.hasAttribute('data-jdm-option-following')) field.removeAttribute('data-jdm-option-following');
            if (visible) precedingVisibleField = true;
          });
        });
        root.querySelectorAll('.gpo-app .gpo-ov-wrapper.horizontal').forEach((group) => {
          const items = Array.from(group.children).filter((item) => item.matches('.gpo-ov-item'));
          if (!items.length || items.some((item) => !item.matches('.gpo-swatches.buttons'))) return;
          const visible = items.filter((item) => !item.hidden && item.getClientRects().length && getComputedStyle(item).display !== 'none' && getComputedStyle(item).visibility !== 'hidden');
          const widths = visible.map((item) => {
            const label = item.querySelector(':scope > label');
            return choiceLabelWidth(label, label?.querySelector('.gpo-ov-title'));
          });
          const gap = parseFloat(getComputedStyle(group).getPropertyValue('--jdm-choice-gap')) || 12;
          const columns = choiceColumnsForWidths(widths, group.clientWidth, gap);
          const assignment = new Map(visible.map((item, index) => [item, columns[index]]));
          items.forEach((item) => {
            const value = assignment.get(item);
            if (value && item.dataset.jdmChoiceColumns !== value) item.dataset.jdmChoiceColumns = value;
            else if (!value && item.hasAttribute('data-jdm-choice-columns')) item.removeAttribute('data-jdm-choice-columns');
          });
          if (visible.length && !group.hasAttribute('data-jdm-choice-rows')) group.setAttribute('data-jdm-choice-rows', '');
          else if (!visible.length && group.hasAttribute('data-jdm-choice-rows')) group.removeAttribute('data-jdm-choice-rows');
        });
      };
      let pending;
      const schedule = () => {
        if (!root.isConnected) {
          sizeObserver?.disconnect();
          optionObserver?.disconnect();
          window.removeEventListener('resize', schedule);
          document.fonts?.removeEventListener('loadingdone', schedule);
          root.removeEventListener('change', schedule);
          return;
        }
        if (pending) return;
        pending = requestAnimationFrame(() => { pending = null; update(); });
      };
      // Observe app visibility/rerender inputs, never our own data attributes.
      optionObserver = new MutationObserver((records) => {
        if (records.some((record) => record.type === 'childList' || (record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('variant-selects,.gpo-app'))) schedule();
      });
      optionObserver.observe(root, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'data-clo-display'] });
      root.addEventListener('change', schedule);
      window.addEventListener('resize', schedule);
      document.fonts?.ready.then(schedule);
      document.fonts?.addEventListener('loadingdone', schedule);
      if (typeof ResizeObserver !== 'undefined') {
        let previousWidth;
        sizeObserver = new ResizeObserver(([entry]) => {
          if (!root.isConnected) { schedule(); return; }
          const width = Math.round(entry.contentRect.width * 10) / 10;
          if (width === previousWidth) return;
          previousWidth = width;
          schedule();
        });
      }
      update();
    });
  }
  function initGalleryShare() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      const sku = root.querySelector('product-info [id^="Sku-"]');
      const share = root.querySelector('.social-share');
      if (!sku || !share) return;
      let skuRow = sku.closest('.jdm-sku-share-row');
      if (!skuRow) {
        skuRow = document.createElement('div');
        skuRow.className = 'jdm-sku-share-row';
        sku.parentNode.insertBefore(skuRow, sku);
        skuRow.appendChild(sku);
      }
      let shareRow = share.closest('.jdm-gallery-share');
      if (!shareRow) {
        shareRow = document.createElement('div');
        shareRow.className = 'jdm-gallery-share';
        const caption = share.previousElementSibling;
        if (caption?.classList.contains('caption')) shareRow.appendChild(caption);
        shareRow.appendChild(share);
      }
      if (shareRow.parentNode !== skuRow) skuRow.appendChild(shareRow);
    });
  }
  function hasMissingRequiredOption(group) {
    const fields = Array.from(group.querySelectorAll('[presence]:not([disabled])'));
    return fields.some((field) => {
      if (field.type === 'radio' || field.type === 'checkbox') {
        const key = field.dataset.name || field.name;
        return !fields.some((other) => (other.dataset.name || other.name) === key && other.checked);
      }
      if (field.type === 'file') {
        const savedFile = Array.from(group.closest('.product').querySelectorAll('.gpo-hidden-inputs [data-field-name]')).find((item) => item.dataset.fieldName === field.dataset.fieldName && !item.disabled && item.value);
        return !field.files?.length && !field.hasAttribute('data-has-file') && !savedFile;
      }
      if (field.tagName === 'SELECT' && field.multiple) return !Array.from(field.selectedOptions).some((option) => !option.disabled && option.value);
      return 'value' in field && !String(field.value).trim();
    });
  }
  function initOptionFeedback() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      if (root.dataset.jdmOptionFeedback) return;
      root.dataset.jdmOptionFeedback = 'true';
      let deadline = 0;
      let pending;
      let expiry;
      let trigger;
      let firstError;
      let freshNativeErrors = false;
      let dialog;
      const visibleErrors = () => Array.from(root.querySelectorAll('.gpo-app .gpo-form__group.has-error')).filter((group) =>
        group.getClientRects().length && getComputedStyle(group).visibility !== 'hidden' && group.querySelector('.messages .help-block.error')?.textContent.trim()
      );
      const focusError = () => {
        const errors = visibleErrors();
        const group = errors.includes(firstError) ? firstError : errors[0];
        if (!group) { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); return; }
        group.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const field = Array.from(group.querySelectorAll('input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),button:not([disabled])')).find((item) => getComputedStyle(item).display !== 'none');
        field?.focus({ preventScroll: true });
        if (!field || document.activeElement !== field) {
          group.setAttribute('tabindex', '-1');
          group.focus({ preventScroll: true });
        }
      };
      const present = (message) => {
        if (dialog?.open) return;
        if (!dialog) {
          dialog = document.createElement('dialog');
          dialog.className = 'jdm-option-error-dialog';
          dialog.setAttribute('role', 'alertdialog');
          dialog.setAttribute('aria-modal', 'true');
          const text = document.createElement('p');
          text.id = `jdm-option-error-${document.querySelectorAll('.jdm-option-error-dialog').length}`;
          dialog.setAttribute('aria-labelledby', text.id);
          const close = document.createElement('button');
          close.type = 'button';
          close.textContent = 'Close';
          close.addEventListener('click', () => dialog.close());
          dialog.append(text, close);
          dialog.addEventListener('close', focusError);
          document.body.appendChild(dialog);
        }
        dialog.querySelector('p').textContent = message;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
          dialog.querySelector('button').focus();
        } else { window.alert(message); focusError(); }
      };
      const check = () => {
        if (!deadline || performance.now() > deadline || !freshNativeErrors) return;
        const nativeDecision = window.GPOConfigs?.diagAtc?.()?.last?.decision;
        if (nativeDecision && nativeDecision !== 'errors') return;
        const errors = visibleErrors();
        if (!errors.length) return;
        deadline = 0;
        clearTimeout(expiry);
        firstError = errors[0];
        // Native validation alone blocks the cart and determines error groups.
        present(errors.some(hasMissingRequiredOption) ? 'Please fill in all required fields.' : 'Please check the highlighted option fields.');
      };
      const schedule = () => {
        if (!deadline || pending) return;
        pending = requestAnimationFrame(() => { pending = null; check(); });
      };
      const isCartControl = (target) => {
        const button = target.closest('button,input[type="submit"]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return null;
        if (button.id === 'sticky-atc-bar-btn') return button;
        if (!root.contains(button) || button.closest('#frequently-bought-together-app-block')) return null;
        return button.matches('[name="add"],.product-form__submit') && button.form?.getAttribute('action')?.includes('/cart/add') ? button : null;
      };
      const arm = (target) => {
        if (!root.isConnected || !root.querySelector('.gpo-app')) return;
        trigger = target;
        freshNativeErrors = false;
        deadline = performance.now() + 2000;
        clearTimeout(expiry);
        expiry = setTimeout(() => { deadline = 0; }, 2000);
      };
      const disarm = () => { deadline = 0; freshNativeErrors = false; clearTimeout(expiry); };
      window.addEventListener('pointercancel', disarm, true);
      window.addEventListener('pointerdown', disarm, true);
      window.addEventListener('input', (event) => { if (root.contains(event.target) && event.target.closest('.gpo-app')) disarm(); }, true);
      // Arm after pointer-induced blur/change, immediately before native click.
      // Globo may stop its own click/submit at window capture; we never replay it.
      window.addEventListener('pointerup', (event) => {
        const button = event.button === 0 ? isCartControl(event.target) : null;
        if (button) arm(button); else disarm();
      }, true);
      window.addEventListener('keydown', (event) => {
        if (root.contains(event.target) && event.target.closest('.gpo-app')) disarm();
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const button = isCartControl(event.target);
        if (button) arm(button);
        else if (event.key === 'Enter' && root.contains(event.target) && event.target.matches('input:not([type="radio"]):not([type="checkbox"])') && event.target.form?.getAttribute('action')?.includes('/cart/add') && !event.target.closest('#frequently-bought-together-app-block')) arm(event.target);
      }, true);
      window.addEventListener('click', (event) => { const button = isCartControl(event.target); if (button) { arm(button); schedule(); } }, true);
      window.addEventListener('submit', (event) => {
        if (root.contains(event.target) && event.target.getAttribute('action')?.includes('/cart/add') && !event.target.closest('#frequently-bought-together-app-block')) { arm(event.submitter || event.target); schedule(); }
      }, true);
      new MutationObserver((records) => {
        if (!deadline) return;
        if (records.some((record) => record.type === 'childList' && record.target.closest?.('.gpo-app .messages'))) freshNativeErrors = true;
        if (freshNativeErrors) schedule();
      }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  function initDescriptionMedia() {
    const scope = 'product-info[id^="MainProduct-"] [data-jdm-product-description]';
    const positive = (value) => /^\d+(?:\.\d+)?(?:px)?$/.test(String(value || '').trim()) ? parseFloat(value) : 0;
    const ratioValue = (value) => {
      const parts = String(value || '').replace(/^auto\s+/, '').trim().split('/');
      const width = positive(parts[0]?.trim());
      const height = parts.length === 1 ? 1 : positive(parts[1]?.trim());
      return width > 0 && height > 0 ? width / height : 0;
    };
    document.querySelectorAll(scope).forEach((description) => {
      description.querySelectorAll('video, iframe').forEach((media) => {
        if (media.dataset.jdmDescriptionMedia) return;
        const isVideo = media.tagName === 'VIDEO';
        let isShort = false;
        if (!isVideo) {
          let url;
          try { url = new URL(media.getAttribute('data-src') || media.getAttribute('src'), document.baseURI); } catch (_) { return; }
          const youtube = /^(www\.)?youtube(?:-nocookie)?\.com$/.test(url.hostname) && /^\/(embed|shorts)\//.test(url.pathname);
          const vimeo = url.hostname === 'player.vimeo.com' && /^\/video\//.test(url.pathname);
          // Charts, app widgets and other non-video iframes keep their own sizing.
          if (!youtube && !vimeo) return;
          isShort = youtube && url.pathname.startsWith('/shorts/');
        }
        const width = positive(media.getAttribute('width')) || positive(media.style.width);
        const height = positive(media.getAttribute('height')) || positive(media.style.height);
        const parent = media.parentElement;
        const soleMedia = parent !== description && parent.children.length === 1 && Array.from(parent.childNodes).every((node) => node === media || node.nodeType === 3 && !node.textContent.trim());
        const ratioBox = soleMedia && (parent.style.height === '0px' || parent.style.height === '0' || media.style.position === 'absolute');
        const padding = ratioBox && (parent.style.paddingBottom || parent.style.paddingTop);
        const paddingRatio = /^(?:\d*\.)?\d+%$/.test(padding || '') && parseFloat(padding) > 0 ? 100 / parseFloat(padding) : 0;
        const wrapperRatio = soleMedia ? ratioValue(parent.style.aspectRatio) || paddingRatio : 0;
        // Keep explicit portrait/square ratios. Unknown iframes have no guessed 16:9 fallback.
        const authoredRatio = ratioValue(media.style.aspectRatio) || (width && height ? width / height : 0) || wrapperRatio || (isShort ? 9 / 16 : 0);
        if (!isVideo && !authoredRatio) return;
        const applyRatio = () => {
          const naturalRatio = isVideo && media.videoWidth > 0 && media.videoHeight > 0 ? media.videoWidth / media.videoHeight : 0;
          const ratio = naturalRatio || authoredRatio;
          if (ratio) media.style.setProperty('--jdm-description-ratio', `${isVideo ? 'auto ' : ''}${ratio}`);
        };
        applyRatio();
        if (width) media.style.setProperty('--jdm-description-width', `${width}px`);
        media.dataset.jdmDescriptionMedia = isVideo ? 'video' : 'iframe';
        if (wrapperRatio) parent.dataset.jdmDescriptionVideoWrapper = 'true';
        if (isVideo) {
          // Metadata follows the existing preload/lazy-loading policy; never call load() or play().
          media.addEventListener('loadedmetadata', applyRatio);
          media.addEventListener('resize', applyRatio);
        }
      });
    });
  }
  function init() {
    initDescriptionMedia();
    initGalleryShare();
    initOptionFeedback();
    initOptionRows();
    initGalleryPreviews();
    initBundleDisclosure();
    const bar = document.getElementById('sticky-prod-header');
    if (!bar || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    const sectionId = bar.dataset.sectionId;
    const identity = document.getElementById(`ProductIdentity-${sectionId}`);
    if (!identity) return;
    document.body.appendChild(bar);
    const updateVisibility = () => {
      const rect = identity.getBoundingClientRect();
      bar.classList.toggle('sph--visible', rect.height > 0 && rect.bottom <= 0);
    };
    let frame;
    window.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { updateVisibility(); frame = null; });
    }, { passive: true });
    window.addEventListener('resize', updateVisibility);
    const sku = document.getElementById(`Sku-${sectionId}`);
    if (sku) {
      const updateSku = () => {
        bar.querySelector('[data-sticky-sku]').textContent = sku.textContent.trim();
        bar.querySelector('.sph-sku').hidden = !sku.textContent.trim();
      };
      new MutationObserver(updateSku).observe(sku, { childList: true, characterData: true, subtree: true });
      updateSku();
    }
    updateVisibility();
  }
  const copyTimers = new WeakMap();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-sku]');
    if (!button) return;
    const source = button.querySelector('[data-sticky-sku]') || button;
    const value = source.textContent.trim();
    const config = document.getElementById('sticky-prod-header');
    const status = document.getElementById('jdm-sku-copy-status');
    if (!value || !config) return;
    let message;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(value);
      message = config.dataset.skuCopied;
    } catch {
      const range = document.createRange();
      range.selectNodeContents(source);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      message = config.dataset.skuCopyFallback;
    }
    button.dataset.copyFeedback = message;
    if (status) status.textContent = `${message} ${value}`;
    clearTimeout(copyTimers.get(button));
    copyTimers.set(button, setTimeout(() => { delete button.dataset.copyFeedback; }, 3000));
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.jdm-review-link');
    if (!link) return;
    const reviews = document.getElementById('wc_review_section');
    if (!reviews) return;
    event.preventDefault();
    reviews.setAttribute('tabindex', '-1');
    reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    reviews.focus({ preventScroll: true });
    history.replaceState(null, '', '#wc_review_section');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', initGalleryPreviews);
  document.addEventListener('product-info:loaded', initDescriptionMedia);
  document.addEventListener('product-info:loaded', initOptionRows);
})();



/* Desktop recommendation placement; restores original app nodes on mobile. */
(() => {
  'use strict';
  const APP_SELECTORS = ['variant-king-combined-listing', '#frequently-bought-together-app-block'];
  const DESKTOP_QUERY = '(min-width: 750px)';
  // These two requested placements are deliberate even if viewport wrapping
  // changes which top column is shorter. Other products use measured content.
  const PREFERRED_COLUMNS = Object.freeze({
    'cobb-tuning-v3-accessport-subaru-wrx-2015-2021-sti-2015-2021-forester-xt-cvt-2014-2018-cobbap3-sub-004-ap3-sub-004': 'info',
    'idoing-head-unit-for-subaru-wrx-sti-2015-2021-including-models-with-harman-kardon': 'media',
  });
  const controllers = new Map();

  function chooseColumn(leftHeight, rightHeight, currentSide, tolerance = 64) {
    if (![leftHeight, rightHeight].every(Number.isFinite)) return currentSide || 'media';
    const difference = rightHeight - leftHeight;
    if (currentSide === 'media') return difference < -tolerance ? 'info' : 'media';
    if (currentSide === 'info') return difference > tolerance ? 'media' : 'info';
    return difference < 0 ? 'info' : 'media';
  }

  function movableRoot(widget, product) {
    let node = widget.closest('.shopify-app-block') || widget;
    const instantWrapper = node.parentElement;
    if (instantWrapper?.hasAttribute('data-no-instant') && instantWrapper.children.length === 1) node = instantWrapper;
    if (!product.contains(node) || node.matches('variant-selects,.gpo-app') || node.querySelector('variant-selects,.gpo-app')) return null;
    // Never sever a form association or move the product's configuration fields.
    if (node.parentElement?.closest('form')) return null;
    return node;
  }

  function moveNode(node, parent, before = null) {
    // Never remove a live widget into a stale/detached destination.
    if (!node?.isConnected || !parent?.isConnected || before && before.parentNode !== parent) return false;
    if (node === before || node.parentNode === parent && node.nextSibling === before) return true;
    const active = node.ownerDocument.activeElement;
    const restoreFocus = active && node.contains(active);
    // moveBefore preserves browser-managed state where supported. App-defined
    // custom-element lifecycle behavior still needs verification on real apps.
    if (typeof parent.moveBefore === 'function' && node.isConnected && parent.isConnected) parent.moveBefore(node, before);
    else parent.insertBefore(node, before);
    if (restoreFocus && node.ownerDocument.activeElement !== active && active.isConnected) active.focus({ preventScroll: true });
    return node.parentNode === parent;
  }

  function installForProduct(product) {
    const doc = product.ownerDocument;
    const win = doc.defaultView;
    let media = product.querySelector(':scope > .product__media-wrapper');
    let gallery = media?.querySelector('theme-media-gallery');
    let info = product.querySelector(':scope > .product__info-wrapper > section');
    let purchasePanel = info?.querySelector(':scope > .product__info-container:first-child');
    if (!gallery || !purchasePanel) return null;
    const desktop = win.matchMedia(DESKTOP_QUERY);
    const entries = new Map();
    let slots;
    let currentSide;
    let pending;
    let destroyed = false;
    let observer;
    let resizeObserver;

    const inProduct = (node) => Boolean(node?.isConnected && product.contains(node));
    const inSlot = (node) => Boolean(slots && Object.values(slots).some((slot) => slot.contains(node)));
    const orderedEntries = () => Array.from(new Set(APP_SELECTORS.map((selector) => entries.get(selector)).filter(Boolean)));
    const reacquireTargets = () => {
      const newMedia = product.querySelector(':scope > .product__media-wrapper');
      const newGallery = newMedia?.querySelector('theme-media-gallery');
      const newInfo = product.querySelector(':scope > .product__info-wrapper > section');
      const newPurchase = newInfo?.querySelector(':scope > .product__info-container:first-child');
      const changed = media !== newMedia || gallery !== newGallery || info !== newInfo || purchasePanel !== newPurchase;
      media = newMedia; gallery = newGallery; info = newInfo; purchasePanel = newPurchase;
      const valid = [media, gallery, info, purchasePanel].every(inProduct);
      if (changed && resizeObserver) {
        resizeObserver.disconnect();
        [gallery, info].filter(inProduct).forEach((node) => resizeObserver.observe(node));
      }
      return valid;
    };
    const repairHome = (entry, selector) => {
      if (inProduct(entry.home) && !inSlot(entry.home)) return entry.home;
      if (!inProduct(entry.node)) return null; // Never resurrect an app removed by its owner.
      const savedParent = inProduct(entry.originParent) && !inSlot(entry.originParent) ? entry.originParent : null;
      const following = entry.following.find((node) => inProduct(node) && !inSlot(node));
      const preceding = entry.preceding.find((node) => inProduct(node) && !inSlot(node));
      // If the original container was rebuilt too, prefer a surviving sibling.
      // Last resort is the current below-media section, then the current root;
      // a connected app remains visible rather than stranded in a desktop slot.
      const fallback = product.querySelector(':scope > .product__media-submedia-wrapper');
      const parent = [savedParent, following?.parentNode, preceding?.parentNode, fallback, product]
        .find((candidate) => inProduct(candidate) && !inSlot(candidate) && !candidate.closest('form') && !entry.node.contains(candidate));
      if (!parent) return null;
      const before = entry.node.parentNode === parent && !inSlot(entry.node) ? entry.node
        : entry.following.find((node) => node.parentNode === parent) || (preceding?.parentNode === parent ? preceding.nextSibling : null);
      const home = doc.createComment(`jdm-recommendation-home: ${selector}`);
      parent.insertBefore(home, before);
      entry.home = home;
      entry.originParent = parent;
      return home;
    };
    const getFinanceAnchor = () => {
      if (!inProduct(purchasePanel)) return null;
      const finance = purchasePanel.querySelector('.jdm-payment-options:not(.jdm-payment-options--sticky), .product__financing');
      if (!inProduct(finance)) return null;
      let anchor = finance;
      while (anchor.parentElement && anchor.parentElement !== purchasePanel) anchor = anchor.parentElement;
      // Right slot is a sibling of the entire buy block, outside any cart form.
      return anchor.parentElement === purchasePanel && !purchasePanel.closest('form') ? anchor : null;
    };

    const collect = (allowNew = true) => {
      APP_SELECTORS.forEach((selector) => {
        const existing = entries.get(selector);
        if (!allowNew && !existing) return;
        const widget = product.querySelector(selector);
        if (!widget) return;
        const node = movableRoot(widget, product);
        if (!node || !inProduct(node)) return;
        if (existing) {
          // Reconcile even immediately before mobile restoration or after the
          // source marker disappeared; wrapper replacement is asynchronous.
          existing.node = node;
          repairHome(existing, selector);
          return;
        }
        if (inSlot(node)) return;
        const shared = orderedEntries().find((entry) => entry.node === node);
        if (shared) { entries.set(selector, shared); return; }
        const parent = node.parentNode;
        const siblings = Array.from(parent.childNodes || parent.children);
        const index = siblings.indexOf(node);
        const home = doc.createComment(`jdm-recommendation-home: ${selector}`);
        parent.insertBefore(home, node);
        entries.set(selector, { node, home, originParent: parent,
          following: siblings.slice(index + 1), preceding: siblings.slice(0, index).reverse() });
      });
    };

    const restore = () => {
      APP_SELECTORS.forEach((selector) => {
        const entry = entries.get(selector);
        if (!entry || !inProduct(entry.node)) return;
        const home = repairHome(entry, selector);
        if (home && inProduct(home.parentNode)) moveNode(entry.node, home.parentNode, home.nextSibling);
      });
      if (slots) {
        // Detached slot contents belong to an external removed subtree and are
        // not revived. Connected originals have been restored before cleanup.
        Object.values(slots).forEach((slot) => { if (!slot.isConnected || !slot.children.length) slot.remove(); });
        if (Object.values(slots).every((slot) => !slot.isConnected)) slots = null;
      }
      currentSide = undefined;
      product.removeAttribute('data-jdm-recommendation-column');
    };

    const place = (side) => {
      const target = slots?.[side];
      if (!inProduct(target)) return false;
      // Order comes from the selector contract, never asynchronous Map insertion.
      const nodes = Array.from(new Set(orderedEntries().map((entry) => entry.node).filter(inProduct)));
      for (let index = nodes.length - 1; index >= 0; index -= 1) {
        if (!inProduct(target) || !inProduct(nodes[index]) || !moveNode(nodes[index], target, nodes[index + 1] || null)) return false;
      }
      currentSide = side;
      product.setAttribute('data-jdm-recommendation-column', side);
      return true;
    };

    const height = (node) => node?.getBoundingClientRect().height || 0;
    const update = () => {
      if (destroyed) return;
      if (!product.isConnected) { destroy(); return; }
      // A mobile-first visit remains untouched. Once we own moved entries,
      // discover replacement wrappers before attempting any restoration.
      if (entries.size) collect(false);
      if (!desktop.matches) { restore(); return; }
      if (!reacquireTargets()) { restore(); return; }
      if (slots && (!inProduct(slots.media) || !inProduct(slots.info)
        || slots.media.parentNode !== media || slots.info.parentNode !== purchasePanel)) restore();
      const financeAnchor = getFinanceAnchor();
      if (!financeAnchor) { restore(); return; } // Fail to unchanged source layout.
      collect();
      if (!entries.size) return;
      const focused = Array.from(entries.values()).some(({ node }) => node.contains(doc.activeElement));
      if (!currentSide && focused) return;
      if (!slots) {
        slots = { media: doc.createElement('div'), info: doc.createElement('div') };
        Object.entries(slots).forEach(([side, slot]) => {
          slot.className = 'jdm-desktop-recommendations';
          slot.dataset.jdmRecommendationsSlot = side;
        });
        media.appendChild(slots.media);
        purchasePanel.insertBefore(slots.info, financeAnchor.nextSibling);
      } else if (slots.info.previousElementSibling !== financeAnchor) {
        moveNode(slots.info, purchasePanel, financeAnchor.nextSibling);
      }
      // Remove app height from the source before measuring. This provisional
      // placement and final choice happen in one animation frame, before paint.
      const previousSide = currentSide;
      if (!place(currentSide || 'media')) { restore(); return; }
      // Measure natural-content children, not stretched grid tracks. Both slots
      // have no margins; their padding and child margins are contained in height.
      // Below-media descriptions span BOTH columns and must never influence
      // this comparison. The gallery excludes its following recommendation slot.
      const leftBase = height(gallery);
      const rightBase = Math.max(0, height(info) - height(slots.info));
      const nextSide = PREFERRED_COLUMNS[product.dataset.productHandle] || chooseColumn(leftBase, rightBase, previousSide);
      if (nextSide !== currentSide && !focused && !place(nextSide)) restore();
    };

    const schedule = () => {
      if (destroyed || pending) return;
      pending = win.requestAnimationFrame(() => { pending = null; update(); });
    };
    const destroy = () => {
      if (destroyed) return;
      destroyed = true;
      observer?.disconnect();
      resizeObserver?.disconnect();
      if (pending) win.cancelAnimationFrame(pending);
      desktop.removeEventListener('change', schedule);
      win.removeEventListener('resize', schedule);
      product.removeEventListener('focusout', schedule);
      product.removeEventListener('change', schedule);
      doc.fonts?.removeEventListener('loadingdone', schedule);
      controllers.delete(product);
    };
    observer = new win.MutationObserver(schedule);
    observer.observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    if (typeof win.ResizeObserver === 'function') {
      resizeObserver = new win.ResizeObserver(schedule);
      [gallery, info].forEach((node) => resizeObserver.observe(node));
    }
    desktop.addEventListener('change', schedule);
    win.addEventListener('resize', schedule);
    product.addEventListener('focusout', schedule);
    product.addEventListener('change', schedule);
    doc.fonts?.ready.then(schedule);
    doc.fonts?.addEventListener('loadingdone', schedule);
    schedule();
    return { update, destroy, entries };
  }

  function init() {
    controllers.forEach((controller, product) => { if (!product.isConnected) controller.destroy(); });
    document.querySelectorAll('product-info[id^="MainProduct-"] .product:has(.jdm-product-identity)').forEach((product) => {
      if (controllers.has(product)) return;
      const controller = installForProduct(product);
      if (controller) controllers.set(product, controller);
    });
  }
  if (typeof document === 'undefined' && typeof module !== 'undefined' && module.exports) {
    module.exports = { PREFERRED_COLUMNS, chooseColumn, movableRoot, moveNode, installForProduct };
  } else {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('product-info:loaded', init);
    document.addEventListener('shopify:section:unload', (event) => controllers.forEach((controller, product) => {
      if (event.target.contains(product)) controller.destroy();
    }));
  }
})();
